import React from 'react';
import { UserOutlined, BellOutlined } from '@ant-design/icons';
import { HEADER_STRINGS } from '../../../shared/Strings';

import './Header.scss';
import { useSelector } from 'react-redux';
import { getSafe } from '../../../shared/utility';
import { USER_DATA } from '../../../shared/const/Routes/statePaths';

const Header = () => {
  const userData = useSelector(state => getSafe(USER_DATA, state));

  const onNotificationsClicked = event => {};

  const handleUserLogoClicked = event => {};

  const getUserName = () => {
    return userData.firstName + ' ' + userData.lastName;
  };

  const layoutStyle = {
    justifyContent: 'space-around',
  };

  return (
    <>
      <div
        className="header-container"
        style={layoutStyle}
        data-test="component-header"
      >
        <div className="epc-logo"></div>
        <div className="header-text">EPC - Emulation Platform Cloud</div>
        <div
          className="notification-layout"
          onMouseDown={e => onNotificationsClicked(e)}
        >
          <BellOutlined className="icon-style" />
          {/* {showIndicatorNotifications && <div className="dot"></div>} */}
        </div>
        <div
          className="right-layout"
          data-test="user-name"
          onMouseDown={e => handleUserLogoClicked(e)}
        >
          {HEADER_STRINGS.HELLO} {getUserName()}
          <UserOutlined className="icon-style" />
        </div>
      </div>
    </>
  );
};
export default Header;
